import styled from "styled-components";
import { useRef } from "react";
import { Link } from "react-router-dom";

const developments = [
  {
    id: "las-retamas",
    name: "Barrio Las Retamas",
    location: "Luján de Cuyo",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
  },
  {
    id: "vista-norte",
    name: "Loteo Vista Norte",
    location: "Maipú",
    image:
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994"
  },
  {
    id: "torre-sur",
    name: "Edificio Torre Sur",
    location: "Mendoza Capital",
    image:
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688"
  },
  {
    id: "los-alamos",
    name: "Barrio Los Álamos",
    location: "Godoy Cruz",
    image:
      "https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6"
  }
];

export default function DevelopmentsSection() {
  const slider = useRef();

  const scrollLeft = () => {
    slider.current.scrollBy({
      left: -320,
      behavior: "smooth"
    });
  };

  const scrollRight = () => {
    slider.current.scrollBy({
      left: 320,
      behavior: "smooth"
    });
  };

  return (
    <Section>

      <Header>

        <Title>
          Nuevos desarrollos en Mendoza
        </Title>

        <Buttons>
          <Arrow onClick={scrollLeft}>‹</Arrow>
          <Arrow onClick={scrollRight}>›</Arrow>
        </Buttons>

      </Header>

      <Slider ref={slider}>

        {developments.map((dev) => (
          <Card
            key={dev.id}
            to={`/desarrollo/${dev.id}`}
          >

            <Image
              style={{
                backgroundImage: `url(${dev.image})`
              }}
            />

            <Content>

              <Name>
                {dev.name}
              </Name>

              <Location>
                {dev.location}
              </Location>

              <Button>
                Ver proyecto
              </Button>

            </Content>

          </Card>
        ))}

      </Slider>

      <Footer>

        <AllLink to="/desarrollos">
          Ver todos los desarrollos
        </AllLink>

      </Footer>

    </Section>
  );
}

const Section = styled.section`
max-width:1300px;
margin:auto;
padding:clamp(80px,10vw,140px) 20px;
`;

const Header = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
margin-bottom:42px;
`;

const Title = styled.h2`
max-width:720px;
margin:0;
font-size:clamp(2.4rem,5vw,5rem);
font-weight:600;
letter-spacing:-0.06em;
line-height:.95;
`;

const Buttons = styled.div`
display:flex;
gap:10px;
`;

const Arrow = styled.button`
border:1px solid #dce4e3;
background:#fcfbf8;
width:46px;
height:46px;
border-radius:50%;
cursor:pointer;
font-size:22px;
color:#2f7088;

:hover{
background:#eaf2f3;
}
`;

const Slider = styled.div`
display:flex;
gap:18px;
overflow-x:auto;
scrollbar-width:none;
scroll-snap-type:x proximity;
padding-bottom:8px;

::-webkit-scrollbar{
display:none;
}
`;

const Card = styled(Link)`
position:relative;
min-width:min(430px,82vw);
height:560px;
border-radius:2px;
overflow:hidden;
background:#e9eeee;
text-decoration:none;
color:white;
scroll-snap-align:start;

:hover{
div:first-child{
transform:scale(1.035);
}
}

@media(max-width:640px){
height:460px;
}
`;

const Image = styled.div`
position:absolute;
inset:0;
background-size:cover;
background-position:center;
transition:transform .6s cubic-bezier(.2,.7,.2,1);

&:after{
content:'';
position:absolute;
inset:0;
background:linear-gradient(180deg,transparent 42%,rgba(19,35,40,.76) 100%);
}
`;

const Content = styled.div`
position:absolute;
z-index:2;
inset:auto 0 0;
padding:32px;

@media(max-width:640px){
padding:24px;
}
`;

const Name = styled.h3`
margin:0 0 7px;
font-size:clamp(1.7rem,3vw,2.5rem);
font-weight:600;
letter-spacing:-.045em;
`;

const Location = styled.p`
color:rgba(255,255,255,.78);
font-size:14px;
margin:0 0 20px;
`;

const Button = styled.div`
font-size:14px;
font-weight:600;
color:white;
text-decoration:underline;
text-underline-offset:6px;
`;

const Footer = styled.div`
margin-top:30px;
text-align:center;
`;

const AllLink = styled(Link)`
font-weight:600;
text-decoration:none;
color:#2f7088;
border-bottom:1px solid currentColor;
padding-bottom:6px;
`;
